import React, {useEffect} from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import {hotjar} from 'react-hotjar'

// config 
import config from "./config"

// providers
import {CatalogueProvider} from "./context/CatalogueContext"
import {ShopProvider} from './context/ShopContext'
import {SearchProvider} from './context/SearchContext'
import {FavouritesProvider} from './context/FavouritesContext'
import {ScrollProvider} from "./context/ScrollContext"

// components
import Scaffolding from "./components/shared/Scaffolding"
import Activity from "./components/views/Catalogue/Activity/Activity"
import ActivityPackage from "./components/views/Catalogue/ActivityPackages/ActivityPackage"
import ActivityPackageList from "./components/views/Catalogue/ActivityPackages/ActivityPackageList"
import Search from "./components/views/Catalogue/Search/Search"
import Favourites from "./components/views/Catalogue/Favourites/Favourites"
import {Cart, Confirm, Done, InitializePayment, FinalizePayment, Packaging, Payment, Personalize} from "./components/views/Checkout"
import Config from "./components/views/Config"
import Kitchensink from "./components/views/Kitchensink"

// the component
function Shop() {
  // initialization of 3rd party libs
  useEffect(() => {
    hotjar.initialize(config.hotjar.hjid, config.hotjar.hjsv)
  }, [])

  // render
  return (
    <Router basename={config.routerBasename}>
      <CatalogueProvider>
        <ShopProvider>
          <SearchProvider>
            <FavouritesProvider>
              <ScrollProvider>
                
                  <Switch>
                    <Route exact path="/" component={Search} />
                    
                    <Route path="/activity/:slug" component={Activity} />
                    <Route path="/packages/:slug" component={ActivityPackage} />
                    <Route path="/packages" component={ActivityPackageList} />
                    <Route path="/checkout/cart" component={Cart} />
                    <Route path="/checkout/packaging" component={Packaging} />
                    <Route path="/checkout/personalize" component={Personalize} />
                    <Route path="/checkout/payment" component={Payment} />
                    <Route path="/checkout/confirm" component={Confirm} />
                    <Route path="/checkout/done" component={Done} />
                    <Route path="/checkout/initializepayment" component={InitializePayment} />
                    <Route path="/checkout/finalizepayment" component={FinalizePayment} />
                    <Route path="/checkout" component={Cart} />
                    <Route path="/favourites" component={Favourites} />
                    <Route path="/kitchensink" component={Kitchensink} />
                    <Route path="/config" component={Config} />
      
                    <Route component={Search} />
                  </Switch>
                
              </ScrollProvider>
            </FavouritesProvider>
          </SearchProvider>
        </ShopProvider>
      </CatalogueProvider>
    </Router>
  )

}

export default Shop